module.exports = __webpack_public_path__ + "img/sms_active.d8ecd442.svg";